import { type MCPServerInfo } from '../../types';

const AirweaveSearchServer: MCPServerInfo = {
  serverId: 'AIRWEAVE_SEARCH',
  name: 'Airweave Search',
  slug: 'airweave-search',
  description: 'Airweave Search MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/airweave-search:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: 'airweave-search'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['airweaveApiKey', 'airweaveCollection'],
    properties: {
      airweaveApiKey: {
        type: 'string',
        description: 'Airweave API Key',
        sensitive: true
      },
      airweaveCollection: {
        type: 'string',
        description: 'Airweave Collection ID',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default AirweaveSearchServer;
